/**
 * KeypadContainer.js
 * Talkroute
 *
 * Created by Vel Genov on 12/30/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import { connect } from "react-redux";

import IdleKeypad from "../components/keypadComponents/IdleKeypad";
import ConnectingKeypad from "../components/keypadComponents/ConnectingKeypad";
import IncomingKeypad from "../components/keypadComponents/IncomingKeypad";
import ConnectedKeypad from "../components/keypadComponents/ConnectedKeypad";
import { CallStateEnum } from "../constants/callConstants";

interface IKeypadContainerProps {
  callState: CallStateEnum;
}

/**
 * Entry point for the user end of the application
 */
class KeypadContainer extends React.Component<IKeypadContainerProps, any> {
  static defaultProps = {
    callState: CallStateEnum.IDLE,
  };

  /**
   * Show the different keypads based on the current call state
   */
  showKeypadForState = () => {
    const { callState } = this.props;

    // IDLE: 'Idle',
    // STARTING_CALL: 'StartingCall',
    // CONNECTING: 'Connecting',
    // CONNECTED: 'Connected',
    // INCOMING: 'Incoming',
    // ACCEPT: 'Accept'

    switch (callState) {
      case CallStateEnum.IDLE:
        return <IdleKeypad />;
      case CallStateEnum.CONNECTING:
        return <ConnectingKeypad />;
      case CallStateEnum.INCOMING:
        return <IncomingKeypad />;
      case CallStateEnum.ACCEPT:
        return <IncomingKeypad />;
      case CallStateEnum.CONNECTED:
        return <ConnectedKeypad />;
      default:
        return <IdleKeypad />;
    }
  };

  render() {
    return this.showKeypadForState();
  }
}

// Redux data binding
const mapStateToProps = (state) => ({
  callState: state.callReducer.callState,
});

export default connect(mapStateToProps, {})(KeypadContainer);
